module.exports = __webpack_public_path__ + "static/media/shirt.8397dda6.jpg";